import { UNSELECTED_KEY } from '../productOptions'
import { HorizonOption } from '../types'
import { sortOptionsByTheme } from '../utils/sortOptions'

import { Choice } from './choice'

interface SelectedChoicesTransformer {
  product: {
    options: HorizonOption[]
    linkedOn?: string | null
  }
  variant: {
    choices: Choice[]
  }
  config?: {
    auroraProductOptions?: boolean
    preselectVariant?: boolean
  }
  theme?: {
    pageTheme?: {
      productOptions?: {
        order?: number[]
      }
    }
  }
}

export const selectedChoicesTransformer = ({
  product,
  variant,
  config,
  theme,
}: SelectedChoicesTransformer) => {
  const {
    sortedOptionKeys,
  }: { sortedOptionKeys: string[] } = config?.auroraProductOptions
    ? sortOptionsByTheme({
        options: product.options,
        themeOrderOverride: theme?.pageTheme?.productOptions?.order || [],
      })
    : { sortedOptionKeys: [] }

  const selectedChoices = config?.auroraProductOptions
    ? sortedOptionKeys.reduce<string[]>((accumulator, optionKey) => {
        const enforceUnselected =
          !config?.preselectVariant && optionKey !== product.linkedOn

        if (enforceUnselected) {
          accumulator.push(UNSELECTED_KEY)
          return accumulator
        }

        const choiceKey = variant.choices.find(
          (choice) => choice.optionKey === optionKey,
        )?.key

        if (choiceKey) {
          accumulator.push(choiceKey)
        }

        return accumulator
      }, [])
    : []

  return { selectedChoices, sortedOptionKeys }
}
